import { Grid, Box, Typography, Container } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();
  return (
    <Container maxWidth="md">
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          display="flex"
          flexDirection="column"
          alignItems="center"
          paddingTop="8rem !important"
        >
          <img src="/assets/icons/brand.png" />
          <Typography variant="h4" paddingTop="3rem !important">
            {t("about-h1")}
          </Typography>
        </Grid>
        <Grid xs={12} md={6} padding="1rem !important">
          <Typography>{t("about-p1")}</Typography>
          <br />
          <Typography>{t("about-p2")}</Typography>
          <br />
          <Typography>{t("about-p3")}</Typography>
          <br />
          <Typography>{t("about-p4")}</Typography>
        </Grid>
        <Grid xs={12} md={6} padding="1rem !important">
          <Typography>{t("about-p5")}</Typography>
          <br />
          <Typography>{t("about-p6")}</Typography>
          <br />
          <Typography>{t("about-p7")}</Typography>
          <br />
          <Typography>{t("about-p8")}</Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default About;
